import EventRegistration from 'lib/event-registration';

class OutsideClickEventRegistration extends EventRegistration {

  constructor(element, clickHandler) {

    super(document, 'mousedown', (event) => this._clickHandler(event));

    this.interestedElement = element;
    this.clickHandler = clickHandler;

  }

  _clickHandler(event) {

    const targetElement = event.target;

    if (targetElement === this.interestedElement || this.interestedElement.contains(targetElement) === true) {
      return;
    }

    this.clickHandler(targetElement, event);

  }

}

export default OutsideClickEventRegistration;